export const DataGridSorting = Object.freeze({
    NoSort: 'noSort',
    Neutral: 'neutral',
    Asc: 'asc',
    Desc: 'desc',
});
